import { useState } from "react";
import { IoSendSharp } from "react-icons/io5";
import emailjs from "@emailjs/browser";

// @ts-ignore
const service: string = process.env.REACT_APP_SERVICE_ID;
// @ts-ignore
const template: string = process.env.REACT_APP_TEMPLATE_ID;
// @ts-ignore
const emailKey: string = process.env.REACT_APP_EMAIL_API_KEY;

export default function Contact() {
  const [sending, setsending] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  const [isEmailInvalid, setIsEmailInvalid] = useState<boolean>(false);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setsending(true);

    //if email is invalid then return
    const emailValidation = await handleValidateEmail();
    if (!emailValidation) {
      setsending(false);
      e.target.email.focus();
      return;
    }

    const request = await emailjs.sendForm(
      service,
      template,
      e.target,
      emailKey
    );
    if (request.status === 200) {
      e.target.reset();
      setsending(false);
      alert("Email sent successfully!!");
    } else {
      setsending(false);
      alert("Something went wrong!!");
    }
  };

  const handleValidateEmail = async () => {
    // @ts-ignore
    const emailValidatorkey: string =
      process.env.REACT_APP_EMAIL_VALITDATOR_KEY;

    const myHeaders = new Headers();
    myHeaders.append("apikey", emailValidatorkey);
    const requestOptions: object = {
      method: "GET",
      redirect: "follow",
      headers: myHeaders,
    };

    const api = `https://api.apilayer.com/email_verification/check?email=${email}`;
    const response = await fetch(api, requestOptions);
    const data = await response.json();
    if (data.format_valid && data.smtp_check) {
      setIsEmailInvalid(false);
      return true;
    } else {
      setIsEmailInvalid(true);
      return false;
    }
  };

  return (
    <div id="Contact" className="max-w-2xl mx-auto mt-24 sm:mt-32 mb-20 px-4">
      <h3 className="font-bold text-lg sm:text-xl dark:text-white">
        Get in touch
      </h3>
      <p className="mb-10 text-subText dark:text-dark_text">
        Have a project or question? Send me a message. I will reply within 12
        hour
      </p>

      <form onSubmit={handleSubmit} id="contactForm">
        <div className="grid md:grid-cols-2 gap-4">
          <div className="flex flex-col">
            <label htmlFor="name" className="mb-2 dark:text-white font-medium">
              Name
            </label>
            <input
              type="text"
              className="bg-grey rounded-md px-4 py-4 border border-grey dark:bg-dark_bg dark:text-dark_text"
              name="name"
              id="name"
              required
              placeholder="type your name"
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="email" className="mb-2 dark:text-white font-medium">
              Email
            </label>
            <input
              type="email"
              style={{ borderColor: isEmailInvalid ? "red" : "" }}
              className="bg-grey rounded-md px-4 py-4 border border-grey dark:bg-dark_bg dark:text-dark_text"
              name="email"
              id="email"
              placeholder="type your email"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            {isEmailInvalid && (
              <span style={{ color: "red" }} className="text-sm">
                Please enter a valid email!
              </span>
            )}
          </div>
          <div className="flex flex-col">
            <label
              htmlFor="message"
              className="mb-2 dark:text-white font-medium"
            >
              Your message
            </label>
            <textarea
              name="message"
              className="bg-grey rounded-md px-4 py-4 border border-grey dark:bg-dark_bg dark:text-dark_text"
              id="message"
              placeholder="tell me how can i help you?"
              cols={10}
              rows={5}
              required
            ></textarea>
          </div>
        </div>

        <button
          type="submit"
          className="flex ml-auto items-center bg-primary px-7 py-2 text-xl mt-8 text-white rounded-md"
        >
          {sending ? "Sending..." : "Send"}{" "}
          {sending ? (
            <svg
              className="animate-spin ml-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          ) : (
            <IoSendSharp className="ml-2" />
          )}
        </button>
      </form>
    </div>
  );
}
